import Lookup from 'src/componentes/select2';
import SvgIcon from 'src/componentes/svg-icon';

const FarolLookup = ({ showDescription = false, ...props }) => {
  const renderFarol = (item) => {
    return (
      item &&
      item.data && (
        <span>
          <SvgIcon
            icon={item.data.icone}
            size={18}
            color={item.data.cor}
            colorHover={item.data.cor}
          ></SvgIcon>
          {showDescription && <span>{item.data.legenda}</span>}
        </span>
      )
    );
  };

  return (
    <Lookup
      labelKey="legenda"
      valueKey="id"
      url="/FarolLookup"
      clearable={false}
      data={{ idsIgnorados: [6] }}
      valueComponent={renderFarol}
      {...props}
    />
  );
};

export default FarolLookup;
